import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';
import { sla, kpi, kpiband, kpiInbox, kpiViewComment, kpiViewWorkFlow, kpiViewHistory, kpiDynamic, filecontent } from './../../../models/slakpi';
import { division, user, department } from './../../../models/admin';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { UserService } from './../../../services/user.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { element } from 'protractor';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
//import { EChartOption} from 'echarts';
declare var google: any;
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  OnEventArgs,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from '../../../toaster.service';
import { RSAHelper } from '../../../models/RSAHelper';
@Component({
  selector: 'app-kpi-view',
  templateUrl: './kpi-view.component.html',
  styleUrls: ['./kpi-view.component.css']
})
export class KPIViewComponent implements OnInit {
  isDataReadMore: boolean = false;
  isLevel1ReadMore: boolean = false;
  isLevel2ReadMore: boolean = false;
  isLevel3ReadMore: boolean = false;

  isShowDataReadMore: boolean = true;
  isShowLevel1ReadMore: boolean = true;
  isShowLevel2ReadMore: boolean = true;
  isShowLevel3ReadMore: boolean = true;
  
  scrollToElement($element): void {
    $element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
  }
  showMykpidetails: boolean = false;
  showMykpichart: boolean = true;
  modalRef: BsModalRef;
  modalDynamicRef: BsModalRef;
  buttonType: any;
  ApproveOrRejectComments: string;
  @ViewChild('WorkflowDialog', { static: false }) WorkflowDialog: TemplateRef<any>;
  @ViewChild('IssueDialog', { static: false }) IssueDialog: TemplateRef<any>;
  @ViewChild('BandDialog', { static: false }) BandDialog: TemplateRef<any>;
  @ViewChild('DynamicLabelDialog', { static: false }) DynamicLabelDialog: TemplateRef<any>;
  @ViewChild('txtTarget', { static: false }) txtTarget: ElementRef;
  @ViewChild('bandolorbtn', { static: false }) bandolorbtn: ElementRef;
  @ViewChild('CommentDialog', { static: false }) CommentDialog: TemplateRef<any>;

  public kpiApproveRejectForm: FormGroup;
  @ViewChild('ApproveRejectDialog', { static: false }) ApproveRejectDialog: TemplateRef<any>;
  isdisableChartFilter: boolean = false;


  //public targetBandbtnElement: HTMLElement;
  public position_band: object = { X: 600, Y: 340 };
  KPIPerformanceTrend_data: any = [];
  gridOptionsHistory: GridOption;
  columnCommentDefinitions: Column[];
  cmtsGrid: AngularGridInstance;
  datasetComments: any;
  issueGrid: AngularGridInstance;
  datasetIssues: any;
  columnIssueDefinitions: Column[];
  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public commentsCount: number;
  public data: any;
  public dynamicAttachments: any = [];
  public trnDynamicLabel_data: any = [];
  public dynamicLabel_data: any = [];
  public dynamicBinding_data: any = []; 
  public kpiViewComment_data: any = [];
  public dynamicRow_data: any = [];
  public kpiViewIssue_data: any;
  public kpiViewWorkflow_data: any;
  public kpiViewHistory_data: any;
  public kpiViewBand_data: any;
  public kpiIssue_data: any;
  public issueComment: string = '';
  public NANRVal: string = '';
  public kpiCodeDetail: kpiInbox;
  public kpiCommentForm: FormGroup;
  public kpiCommentDownForm: FormGroup;
  public kpiRuleForm: FormGroup;
  public defaultyear: number = 1;
  public kpiTrnUno: number = 0;
  public kpiUno: number = 0;
  public scheduleUno_gloabl: number = 0;
  public condition2_data: any;
  public condition3_data: any;
  public commentStartIndex: number = 1;
  public commentMaxCount: number = 50;
  disableMore: boolean = true;
  public workflowStartIndex: number = 1;
  public workflowMaxCount: number = 25;
  workflowdisableMore: boolean = true;
  public actualTrend: string = '';
  public historyStartIndex: number = 1;
  public historyMaxCount: number = 50;
  historydisableMore: boolean = true;
  public band_calculated: string = '';
  //public loggedInUser: number = 9;
  public currentLevelUser: string = '';
  public currentLevel: number;
  public isCurrentLevelUser: boolean = false;
  public isChartVisible: boolean = false;
  public actualTargetValue: number;
  public scheduleTypeUno: number = 0;
  public scheduleUno: number = 0;
  user: any = {};
  login_UserID: string; // number
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  isAdmin: boolean = false;

  public dynamicLabelDisplay: string;
  public dynamicLabel: string;
  public isDynamicEntry: string = 'false';
  AttachmentList: any;
  fileItemCount: any;
  fileContent: any;
  public uploadedFiles: Array<File> = [];
  public path: Object = {
    saveUrl: environment.apiBase + '/api/SLAKPI/DynamicEntry_FileUpload'
    // removeUrl: environment.apiBase + '/api/SLAKPI/SLA_FileRemove'
  };
  profilePicture: any = '/assets/img/user-default.png';
  noDataImg: any;
  tenantUno: any;

  chartOption: any = {};
    chartType_data: any=[];
  public chartValue: string = 'quarter';
  constructor(public restApi: SLAKPIApiService, private modalService: BsModalService, private toaster: ToasterService, private _activatedRoute: ActivatedRoute, public router: Router, public utilityService: UtilityService, private userService: UserService, private spinner: SpinnerVisibilityService, private formBuilder: FormBuilder, public http: HttpClient,public RASHelper: RSAHelper) {
  }

  ngOnInit() {
    this.userService.CheckLogin();
    this.gridOptionsHistory = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 5
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
    this.user = this.userService.getUserInfo();
    this.profilePicture = this.user.profilePicture;
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'SLA Admin' || this.user.role == 'DDAdmin') ? true : false;
    this.currentYear = this.user.currentYear;
    this.defaultyear = this.user.currentYear;
    this.currentHalf = this.user.currentHalf;
    this.currentQuarter = this.user.currentQuarter;
    this.currentMonth = this.user.currentMonth;
    this.isDynamicEntry = this.user.isDynamicEntry;
    this.pageSettings = { pageSize: 10, pageSizes: true };
    this.filterSettings = { type: 'Excel' };
    this.band_calculated='gray-bar'

    this.isChartVisible = false;
    this.getChartTypeData();
    this._activatedRoute.params.subscribe((params: Params) => {

      if (params['id'] != null) {
        let kpiTrnUnoTemp = params['id'];
        this.kpiTrnUno = kpiTrnUnoTemp;
        this.loadKPIDynamicTransaction(this.kpiTrnUno);
        this.loadKPICodeDetails(this.kpiTrnUno);
       this.getMstKPIDynamicAttachments(this.kpiTrnUno);
       
        //this.getFiles(this.kpiTrnUno);
        //this.loadKPIViewComments(this.kpiTrnUno, true);
        
        this.showKPIWorkflow();
      }
    });

    this.kpiCommentForm = new FormGroup({
      comment: new FormControl()
    });

    this.kpiCommentDownForm = new FormGroup({
      comment: new FormControl()
    });
    this.kpiApproveRejectForm = new FormGroup({
      comment: new FormControl()
    });
    this.kpiRuleForm = new FormGroup({
      comment: new FormControl(),
      justification: new FormControl(),
      enteredTargetValue: new FormControl(),
      selectNANR: new FormControl(),
      selectPassFail: new FormControl()
    });
    this.kpiViewBand_data = new kpiband();
    this.kpiCodeDetail = new kpiInbox();
    this.condition2_data = [
      { text: 'NA', value: 'NA' },
      { text: 'NR', value: 'NR' },
      { text: 'ND', value: 'ND' }
    ];
    this.condition3_data = [
      { text: 'Pass', value: 'Pass' },
      { text: 'Fail', value: 'Fail' },      
    ];

   // this.initilaizeBandTarget();
    //google.charts.load('current', { 'packages': ['bar'] });
    //google.charts.setOnLoadCallback(this.kpipertrend);
  }
  
  ////// Initialize the Dialog component's target element.
  ////initilaizeBandTarget: EmitType<object> = () => {
  ////  if (this.bandolorbtn != null && this.bandolorbtn != undefined)
  ////    this.targetBandbtnElement = this.bandolorbtn.nativeElement;
  ////}

  //Get KPI Code Details
  loadKPICodeDetails(kpiTrnUno: number) {
    
  
    this.spinner.show();
    let inpValue = new kpiInbox();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 2;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;

    this.restApi.getKpiCodeDetails(inpValue)
      .subscribe(data => {
        
        //this.data = data;
        if (data != null && data != undefined) {
          //this.kpiCodeDetail = new kpiInbox();
          this.kpiCodeDetail = data[0];

          this.dynamicLabel = this.kpiCodeDetail.dynamicLabel;
          this.getDynamicLabelData(this.dynamicLabel);

          if (this.kpiCodeDetail.scheduleUno == 1)
            this.chartValue = 'year';
          if (this.kpiCodeDetail.scheduleUno == 2 || this.kpiCodeDetail.scheduleUno == 3)
            this.chartValue = 'quarter';
          if (this.kpiCodeDetail.scheduleUno == 4)
            this.chartValue = 'month';

          if (this.kpiCodeDetail != null && this.kpiCodeDetail.dataOwnerActionBy == '') {
            this.scheduleUno = this.kpiCodeDetail.scheduleUno;
            this.scheduleTypeUno = this.kpiCodeDetail.bandScheduleTypeUno;
            this.NANRVal = '';
            this.kpiRuleForm.setValue({
              enteredTargetValue: this.kpiCodeDetail.targetValue,
              comment: this.kpiCodeDetail.dataOwnerComments,
              justification: this.kpiCodeDetail.justificationText,
              selectNANR: (this.kpiCodeDetail.isNANRNT == 'NA' ? true : false),
              selectPassFail: this.kpiCodeDetail.passFail
            });
            if (this.kpiCodeDetail.isNANRNT == 'NA') {
              this.kpiRuleForm.get('enteredTargetValue').reset();
              this.kpiRuleForm.get('enteredTargetValue').disable();

              this.kpiRuleForm.get('selectPassFail').reset();
              this.kpiRuleForm.get('selectPassFail').disable();
              this.NANRVal = 'NA';
              this.band_calculated = 'gray-bar';
            }
            if (this.kpiCodeDetail.bandColour != '') {
              this.band_calculated = (this.kpiCodeDetail.bandColour == 'Red') ? 'red-bar' :
                (this.kpiCodeDetail.bandColour == 'Orange') ? 'orange-bar' :
                  (this.kpiCodeDetail.bandColour == 'Yellow') ? 'yellow-bar':
                    (this.kpiCodeDetail.bandColour == 'Light Green') ? 'light-green-bar' : (this.kpiCodeDetail.bandColour == 'Green') ? 'green-bar' : 'gray-bar';
            }
            else {
              this.band_calculated = 'gray-bar';
            }
          }
          
           
          //if (this.kpiCodeDetail.justificationText == '' || this.kpiCodeDetail.justificationText == null) {
          //  this.kpiRuleForm.get('justification').reset();
          //  this.kpiRuleForm.get('justification').disable();
          //}
          //else {
          //  this.kpiRuleForm.get('justification').enable();
          //}

          this.kpiUno = data[0].kpiUno;
          this.scheduleUno_gloabl = data[0].scheduleUno;
        //  this.getSchduleTypeNo();
         // this.actualTargetValue = (this.kpiCodeDetail.actualValue != null && this.kpiCodeDetail.actualValue != '') ? parseInt(this.kpiCodeDetail.actualValue) : 0;

          this.actualTargetValue = (this.kpiCodeDetail.actualValue != null && this.kpiCodeDetail.actualValue != '') ? parseFloat(this.kpiCodeDetail.actualValue) : 0;

          this.actualTrend = this.kpiCodeDetail.trendUno;
          this.checkCurrentUserAndLevel(data);
          this.loadKPIViewHistory(this.kpiUno, true);
          this.loadKPIViewBand(this.kpiUno);
          this.viewKPIChart(this.kpiUno);
          
          //band color
          if (this.currentLevel > 0 && this.isCurrentLevelUser) {
          if (this.kpiCodeDetail.bandColour != '') {
            this.band_calculated = (this.kpiCodeDetail.bandColour == 'Red') ? 'red-bar' :
              (this.kpiCodeDetail.bandColour == 'Orange') ? 'orange-bar' :
                (this.kpiCodeDetail.bandColour == 'Yellow') ? 'yellow-bar' :
                  (this.kpiCodeDetail.bandColour == 'Light Green') ? 'light-green-bar' : (this.kpiCodeDetail.bandColour == 'Green') ? 'green-bar' : 'gray-bar';
          }
          else {
            this.band_calculated = 'gray-bar';
          }
         }
        }
        //this.loadProgressChart(this.kpiCodeDetail[0]);
        this.spinner.hide();
        this.isChartVisible = true;
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  //Get KPI View Comments
  loadKPIViewComments(kpiTrnUno: number, isStart) {
    
    this.spinner.show();
    let inpValue = new kpiViewComment();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.commentStartIndex = (this.commentStartIndex == undefined || this.commentStartIndex < 1 || isStart) ? 1 : this.commentStartIndex;
    inpValue.startIndex = this.commentStartIndex;
    inpValue.maxCount = this.commentMaxCount;

    this.restApi.getKpiViewComments(inpValue)
      .subscribe(data => {
        
        let objData: any = data;
        
        //if (this.commentStartIndex == 1) {
        //  this.kpiViewComment_data = [];
        //  this.kpiViewComment_data = objData;
        //}
        //else {
        //  for (var i = 0; i < objData.length; i++) {
        //    this.kpiViewComment_data.push(objData[i]);
        //  }
        //}
        //if the result set is lessthen 10 then disable the load more icon
        this.disableMore = (objData.length >= 5) ? false : true;
        if (objData.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.commentStartIndex = this.commentStartIndex + 1;
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  //Get KPI View KPI Workflow
  loadKPIViewKPIWorkflow(kpiTrnUno: number, isStart) {

   // this.spinner.show();
    let inpValue = new kpiViewWorkFlow();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.workflowStartIndex = (this.workflowStartIndex == undefined || this.workflowStartIndex < 1 || isStart) ? 1 : this.workflowStartIndex;
    inpValue.startIndex = this.workflowStartIndex;
    inpValue.maxCount = this.workflowMaxCount;
    
    this.restApi.getKpiViewKPIWorkflow(inpValue)
      .subscribe(data => {
        
        let rtnData: any = data;
        let objData: any = rtnData.data;

        if (this.workflowStartIndex == 1) {
          this.kpiViewWorkflow_data = [];
          this.kpiViewWorkflow_data = objData;
        }
        else {
          for (var i = 0; i < objData.length; i++) {
            this.kpiViewWorkflow_data.push(objData[i]);
          }
        }

        this.commentsCount = this.kpiViewWorkflow_data.filter(x => x.comment != '').length;
        //if the result set is lessthen 10 then disable the load more icon
        this.workflowdisableMore = (objData.length >= 5) ? false : true;
        if (objData.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.workflowStartIndex = this.workflowStartIndex + 1;
        }

        //this.WorkflowDialog.show();
        //this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });


  }
  getDynamicLabelData(dynamicLabel: string) {

    
    let dynamicData = [];
    let strlabel = dynamicLabel;
    this.dynamicLabel_data = [];
    if (dynamicLabel != null && dynamicLabel != '') {
      dynamicData = dynamicLabel.split(' ');
      setTimeout(() => {
        for (var i = 0; i < dynamicData.length; i++) {
          if (dynamicData[i].indexOf('@') != -1) {
            this.dynamicLabel_data.push(dynamicData[i]);

            let filterData = this.trnDynamicLabel_data.filter(x => x.kpiDynamicLabel == dynamicData[i]);
            if (filterData.length > 0 && filterData[0].kpiDynamicValue != null) {
              strlabel = strlabel.replace(dynamicData[i], filterData[0].kpiDynamicValue);

              //this.dynamicLabelDisplay = strlabel;
            }

            this.dynamicLabelDisplay = strlabel;
          }
          else {
            //this.dynamicLabelDisplay = strlabel;
          }


        }



      }, 1000);

    }
    else {
      this.dynamicLabel_data = [];
    }


  }
  //Get KPI Band
  loadKPIViewBand(kpiUno: number) {

    this.spinner.show();
    let inpValue = new kpiband();
    inpValue.kpiUno = kpiUno;
    inpValue.kpiYear = this.defaultyear;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    inpValue.scheduleUno = this.scheduleUno; //this.scheduleTypeUno;
    inpValue.scheduleTypeUno = this.scheduleTypeUno;
    this.restApi.getkpiViewBand(inpValue)
      .subscribe(data => {
        this.kpiViewBand_data = data[0];

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  getSchduleTypeNo() {
    //for Year
    if (this.scheduleUno_gloabl == 1) {
      this.scheduleTypeUno = 19;
    }
    //for Half Year
    else if (this.scheduleUno_gloabl == 2) {
      this.scheduleTypeUno = (this.currentHalf == 1) ? 1 : 2;
    }
    //for Quater
    else if (this.scheduleUno_gloabl == 3) {
      this.scheduleTypeUno = (this.currentQuarter == 1) ? 3 : (this.currentQuarter == 2) ? 4 : (this.currentQuarter == 3) ? 5 : 6;
    }
    //for Month
    else if (this.scheduleUno_gloabl ==4) {
      this.scheduleTypeUno = (this.currentMonth == 1) ? 7 : (this.currentMonth == 2) ? 8 : (this.currentMonth == 3) ? 9 :
        (this.currentMonth == 4) ? 10 : (this.currentMonth == 5) ? 11 : (this.currentMonth == 6) ? 12 : (this.currentMonth == 7) ?
          13 : (this.currentMonth == 8) ? 14 : (this.currentMonth == 9) ? 15 : (this.currentMonth == 10) ? 16
            : (this.currentMonth == 11) ? 17 : 18;
    }
  }
  //Get KPI History
  loadKPIViewHistory(kpiUno: number, isStart) {
    this.spinner.show();
    let inpValue = new kpiViewHistory();
    inpValue.kpiUno = kpiUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;;
    this.historyStartIndex = (this.historyStartIndex == undefined || this.historyStartIndex < 1 || isStart) ? 1 : this.historyStartIndex;
    inpValue.startIndex = this.historyStartIndex;
    inpValue.maxCount = this.historyMaxCount;

    this.restApi.getkpiViewHistory(inpValue)
      .subscribe(data => {
        
        let objData: any = data;
        

        
        if (this.historyStartIndex == 1) {
          this.kpiViewHistory_data = [];
          this.kpiViewHistory_data = objData;
        }
        else {
          for (var i = 0; i < objData.length; i++) {
            this.kpiViewHistory_data.push(objData[i]);
          }
        }


        const mockDataset = [];
        for (let i = 0; i < this.kpiViewHistory_data.length; i++) {
          mockDataset[i] = {
            id: i + 1,
            postedBy: this.kpiViewHistory_data[i].enteredBy,
            postedDate: this.kpiViewHistory_data[i].enteredDate,
            comment: this.kpiViewHistory_data[i].comment,
          };
        }
        
        this.datasetComments = mockDataset;
        this.setCommentDefn();


        //if the result set is lessthen 10 then disable the load more icon
        this.historydisableMore = (objData.length >= 5) ? false : true;
        if (objData.length > 0) {
          //this.ifcountgreaterthanzero = true;
          this.historyStartIndex = this.historyStartIndex + 1;
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  loadKPIDynamicTransaction(kpiTrnUno: number) {

    this.spinner.show();
    let inpValue = new kpiDynamic();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getKpiDynamicsTransaction(inpValue)
      .subscribe(data => {

        // let objData: any = data;
        
        this.trnDynamicLabel_data = data;

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  //getMstKPIDynamicAttachments(kpiTrnUno: number) {

  //  this.spinner.show();
  //  let inpValue = new kpiDynamic();
  //  inpValue.kpiTrnUno = kpiTrnUno;

  //  this.restApi.getKpiDynamicsAttachment(inpValue)
  //    .subscribe(data => {

  //      // let objData: any = data;
  //      
  //      this.dynamicAttachments = data;

  //      this.spinner.hide();
  //    },
  //      (error) => {
  //        //Called when error
  //        this.spinner.hide();
  //      }
  //    ).add(() => {
  //      //Called when operation is complete (both success and error)
  //      this.spinner.hide();
  //    });
  //}
  showKPIWorkflow() {
    this.loadKPIViewKPIWorkflow(this.kpiTrnUno, true);
    this.viewKPIIssue(this.kpiTrnUno);
  }

  showKPIBand() {
    this.loadKPIViewBand(this.kpiUno);
    this.modalRef = this.modalService.show(
      this.BandDialog,
      Object.assign({}, {
        class: 'gray modal-medium-sm',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }
  showKPIComment() {
    this.modalRef = this.modalService.show(
      this.CommentDialog,
      Object.assign({}, {
        class: 'gray modal-medium',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  onAddComment() {
    
    if (this.kpiCommentDownForm.invalid) {
      //Swal.fire('Error', 'Something went wrong', 'error')
      this.toaster.show('error', 'Error', 'Something went wrong.');
      return false;
    }
    else {

      let comment = this.kpiCommentDownForm.get('comment').value;
      this.AddEditKPIViewComment(comment,'down');
    }
  }
  checkCurrentUserAndLevel(data: any) {
    debugger;
    this.currentLevelUser = '';
    this.currentLevel = 0;
    //checking Current level

    //currentLevel 0 - Data Entry
    //currentLevel 1 - Level 1 
    //currentLevel 2 - Level 2 
    //currentLevel 3 - Level 3
    let dataEntry = data[0].dataOwnerActionBy;
    let level1Approved = data[0].level1Approved;
    let level2Approved = data[0].level2Approved;
    let level3Approved = data[0].level3Approved;

    if (dataEntry == "" && level1Approved == 0 && level2Approved == 0 && level3Approved == 0) {
      this.currentLevel = 0;
      this.currentLevelUser = data[0].dataOwnerUno;
    }
    else if (dataEntry != "" && level1Approved == 0 && level2Approved == 0 && level3Approved == 0) {
      this.currentLevel = 1;
      this.currentLevelUser = data[0].level1ApproverUno;
    }
    else if (dataEntry != "" && level1Approved == 1 && level2Approved == 0 && level3Approved == 0) {
      this.currentLevel = 2;
      this.currentLevelUser = data[0].level2ApproverUno;
    }
    else if (dataEntry != "" && level1Approved == 1 && level2Approved == 1 && level3Approved == 0) {
      this.currentLevel = 3;
      this.currentLevelUser = data[0].level3ApproverUno;
    }

    if (level1Approved == 1 && level2Approved == 1 && level3Approved == 1) {
      this.currentLevel = 4;
    }

    //Checking whether loggged user and current level user same or not
    //this.kpiCodeDetail.currentLevel = currentLevel;

    
    let login_UserID = this.RASHelper.decryptWithPrivateKey(this.login_UserID.toString());
    //currentLevelUser = "2,3";
    if (this.currentLevelUser.toString().indexOf(',') > -1) {
      
      let userArr = this.currentLevelUser.toString().split(',');
      for (let num of userArr) {
        
        if (login_UserID.toString() == num) {
          this.isCurrentLevelUser = true;
        }
      }
    }
    else {      
      if (login_UserID.toString() == this.currentLevelUser.toString()) {
        this.isCurrentLevelUser = true;
      }
    }

    if (this.isAdmin) { this.isCurrentLevelUser = true; }
  }

  //loadProgressChart(data: any) {


  //  this.dataRelease_Name = data.dataRleasedBy;
  //  this.dataRelease_Date = data.dataRleasedOn;
  //  this.dataEntry_Name = data.dataOwnerActionBy;
  //  this.dataEntry_Date = data.dataOwnerActionOn;
  //  this.dataApprover1_Name =  data.dataRleasedBy;
  //  this.dataApprover1_Date = data.dataRleasedBy;
  //  this.dataApprover2_Name = data.dataRleasedBy;
  //  this.dataApprover2_Date = data.dataRleasedBy;
  //  this.dataApprover3_Name = data.dataRleasedBy;
  //  this.dataApprover3_Date = data.dataRleasedBy;


  //  this.dataRejected1_Name
  //  this.dataRejected1_Date
  //  this.dataRejected1_Uno:
  //  this.dataRejected2_Name
  //  this.dataRejected2_Date
  //  this.dataRejected2_Uno:
  //  this.dataRejected3_Name
  //  this.dataRejected3_Date
  //  this.dataRejected3_Uno:


  //  

  //}
  addComment() {
    let comment = this.kpiCommentForm.get('comment').value;
    comment = (comment != null) ? comment : '';
    if (comment == '') {
      this.toaster.show('warning', 'Warning', 'Please enter comment.');
      return false;
    }
    else { this.AddEditKPIViewComment(comment, 'top');}
    


  }
  getMoreComment() {
    this.loadKPIViewComments(this.kpiTrnUno, false);
  }

  getMoreWorkflow() {
    this.loadKPIViewKPIWorkflow(this.kpiTrnUno, false);
  }

  getMoreHistory() {
    this.loadKPIViewHistory(this.kpiUno, false);
  }

  onSubmit(slaRuleUno: number,type:string) {
    
    

    let selectNANR = null;
    let comment = '';
    let justification = '';
    let targetEnValue = 0;
    let passfail = '';
    
    //Get Selected Vlaues
    selectNANR = (this.NANRVal == null || this.NANRVal == undefined || this.NANRVal=='' ) ? '' : 'NA';
    let objTargetEnValue = this.kpiRuleForm.get('enteredTargetValue').value;
    comment = this.kpiRuleForm.get('comment').value;
    justification = this.kpiRuleForm.get('justification').value;
    //Set Target if Rule is text [Pass--100 / Fail --0]
    if (slaRuleUno == 4) {
      passfail = (this.kpiRuleForm.get('selectPassFail') != null) ? this.kpiRuleForm.get('selectPassFail').value : '';
      if (selectNANR != 'NA') {
        if (passfail == undefined || passfail == null || passfail == '') {
         // Swal.fire('Error', 'Please Select Pass/Fail', 'error');
          this.toaster.show('error', 'Error', 'Please Select Pass/Fail.');
          return false;
        }
        if (passfail == 'Fail') { //this.NANRVal != '' ||
          if (justification == null || justification.trim() == '' ) {
            //Swal.fire('Error', 'Please Enter Justification', 'error')
            this.toaster.show('error', 'Error', 'Please Enter Justification');
            //this.txtDataEntryError = 'Please Enter Approver Comment';
            //this.isDataEntryError = true;
            //this.kpiRuleForm.get('justification').enable();
            return false;
          }
        }
      }
      

    }

    //Target Value validation
    targetEnValue = (objTargetEnValue != '' && objTargetEnValue != null) ? parseFloat(objTargetEnValue) : 0;
    //if ((this.txtTarget.value == null || this.txtTarget.value.toString() == '' || objTargetEnValue == null || objTargetEnValue == '') && selectNANR == '') {
    if (targetEnValue == 0 && (selectNANR == '' || selectNANR == null || selectNANR == undefined) && (slaRuleUno == 1 || slaRuleUno == 2)) {
     // Swal.fire('Error', 'Please Enter the Target Value', 'error');
      //return false;
      targetEnValue = 0;
    }
   

    
    //Comment require
    //if (this.NANRVal != '' || passfail == 'Fail' || passfail == 'fail') {
    // // let comment = this.kpiRuleForm.get('comment').value;
    //  if (comment == '' || comment == null) {
    //    Swal.fire('Error', 'Please Enter Approver Comment', 'error')
    //    return false;
    //  }
    //}

   // if (slaRuleUno == 1 || slaRuleUno == 2 || slaRuleUno == 3) {
      
    
      //if (targetEnValue <= 0 && slaRuleUno != 3 && selectNANR != '') {
      //  Swal.fire('Error', 'Please Enter the Target Value', 'error')
      //  return false;
      //}
      //if (targetEnValue < 0 && slaRuleUno == 3 && selectNANR != '') {
      //  Swal.fire('Error', 'Please Enter the Target Value', 'error')
      //  return false;
      //}

    //}
   

    let objKPIView = new kpiViewWorkFlow();
    objKPIView.action = 'Send for Approval by Data Owner';
    objKPIView.selectedNANR = this.NANRVal ;
    objKPIView.kpiTrnUno = this.kpiTrnUno;
    objKPIView.comment = (comment == null || comment == undefined) ? '' : comment;
    objKPIView.justification = (justification == null || justification == undefined) ? '' : justification;
    objKPIView.userUno = this.login_UserID;
    objKPIView.passFail = passfail;
    objKPIView.targetEnteredValue = targetEnValue;
    objKPIView.condition = 0;//(this.pageAction == "add") ? 0 : 1;
    objKPIView.saveAction = type;
    

    if (slaRuleUno == 1 || slaRuleUno == 2 || slaRuleUno == 3) {


      let classname:string = '';
      let band1Value1 = this.kpiViewBand_data.band1Value1;
      let band2Value1 = this.kpiViewBand_data.band2Value1;
      let band3Value1 = this.kpiViewBand_data.band3Value1;
      let band4Value1 = this.kpiViewBand_data.band4Value1;
      let band5Value1 = this.kpiViewBand_data.band5Value1;
      let band1Condition1 = this.kpiViewBand_data.band1Condition1;
      let band2Condition1 = this.kpiViewBand_data.band2Condition1;
     
      
      let bandfinalcolor = '';
      if (this.NANRVal == '') {
        classname = this.getBadcolorFinal(slaRuleUno, targetEnValue, band1Value1, band2Value1, band3Value1, band4Value1, band5Value1, band1Condition1, band2Condition1);
        if (classname == '') { this.band_calculated = 'gray-bar'; return false; } else { this.band_calculated = classname; }

      }
      
      //Comment require
      if (this.NANRVal == '' && this.getWellPerform(slaRuleUno, classname) == 0) {

        if (objKPIView.justification == null || objKPIView.justification.trim() == '' ) {
         // Swal.fire('Error', 'Please Enter Justification', 'error')
          this.toaster.show('error', 'Error', 'Please Enter Justification.');
          //this.txtDataEntryError = 'UnderPerformed KPI: Please Enter Approver Comment';
          //this.isDataEntryError = true;
          //this.kpiRuleForm.get('justification').enable();
          return false;
        }
      }

      //if (this.uploadedFiles.length > 5) {
      //  this.toaster.show('error', 'Error', 'You can upload maximum 5 files');
      //  return false;
      //}
      //if (this.NANRVal == '') {
      //  Swal.fire({
      //    title: 'Do you want to continue with the below Band Color ?',
      //    html:
      //      '<div class="line-bg"><span class="' + classname + '"></span></div>',
      //    type: 'info',
      //    showCancelButton: true,
      //    confirmButtonText: 'Yes',
      //    cancelButtonText: 'No'
      //  }).then((result) => {
      //    if (result.value) {

      //      if (classname == 'red-bar') {
      //        objKPIView.bandColorFinal = 'Red';
      //      }
      //      else if (classname == 'orange-bar') {
      //        objKPIView.bandColorFinal = 'Orange';
      //      }
      //      else if (classname == 'yellow-bar') {
      //        objKPIView.bandColorFinal = 'Yellow';
      //      }
      //      else if (classname == 'light-green-bar') {
      //        objKPIView.bandColorFinal = 'Light Green';
      //      }
      //      else if (classname == 'green-bar') {
      //        objKPIView.bandColorFinal = 'Green';
      //      }

      //      objKPIView.isWellPerformed = this.getWellPerform(slaRuleUno, classname);
      //      this.CallUpdate(objKPIView);

      //      return;
      //    } else if (result.dismiss === Swal.DismissReason.cancel) {
      //      return;
      //    }
      //  })

      //}
      //else {
      //  objKPIView.isWellPerformed = this.getWellPerform(slaRuleUno, classname);
      //  objKPIView.bandColorFinal = '';
      //  this.CallUpdate(objKPIView);
      //}
      if (this.NANRVal == '') {
        if (classname == 'red-bar') {
          objKPIView.bandColorFinal = 'Red';
        }
        else if (classname == 'orange-bar') {
          objKPIView.bandColorFinal = 'Orange';
        }
        else if (classname == 'yellow-bar') {
          objKPIView.bandColorFinal = 'Yellow';
        }
        else if (classname == 'light-green-bar') {
          objKPIView.bandColorFinal = 'Light Green';
        }
        else if (classname == 'green-bar') {
          objKPIView.bandColorFinal = 'Green';
        }
      }
      if (type == 'submit') {
        let htmldisplay = (this.NANRVal == '') ? '<div style="padding-left:115px"> <table class="table" style="border:none"><tr style="border:0;"><td width="10%"> Performance:</td><td> <span class="' + classname + '" style="position:inherit!important"></span></td></table></div>' :
          '<div style="padding-left:115px"> <table class="table" style="border:none"><tr style="border:0;"><td width="10%"> Performance:</td><td> <span style="position:inherit!important">NA</span></td></table></div>';

        Swal.fire({
          title: 'Please Confirm to Send for Approval',
          html: htmldisplay,
          type: 'info',
          showCancelButton: true,
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.value) {

            objKPIView.isWellPerformed = this.getWellPerform(slaRuleUno, classname);
            this.CallUpdate(objKPIView);

            return;
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            return;
          }
        })
      }
      else {
        objKPIView.isWellPerformed = this.getWellPerform(slaRuleUno, classname);
        this.CallUpdate(objKPIView);
      }
    }
    else {
      if (type == 'submit') {
        let classname = (passfail != '' && passfail == 'Pass') ? 'green-bar' : 'red-bar'
        Swal.fire({
          title: 'Please Confirm to Send for Approval',
          html:
            (this.NANRVal == '') ? '<div style="padding-left:115px"> <table class="table" style="border:none"><tr><td width="10%"> Performance:</td><td> <span class="' + classname + '" style="position:inherit!important"></span></td></table></div>' :
              '<div style="padding-left:115px"> <table class="table" style="border:none"><tr><td width="10%"> Performance:</td><td> <span style="position:inherit!important">NA</span></td></table></div>',
          type: 'info',
          showCancelButton: true,
          confirmButtonText: 'Ok',
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.value) {
            if (this.NANRVal == '') {
              objKPIView.bandColorFinal = (passfail != '' && passfail == 'Pass') ? 'Green' : 'Red';
              objKPIView.isWellPerformed = (passfail != '' && passfail == 'Pass') ? 1 : 0;
            }
            this.CallUpdate(objKPIView);

            return;
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            return;
          }
        })
      }
      else {
        if (this.NANRVal == '') {
          objKPIView.bandColorFinal = (passfail != '' && passfail == 'Pass') ? 'Green' : 'Red';
          objKPIView.isWellPerformed = (passfail != '' && passfail == 'Pass') ? 1 : 0;
        }
        this.CallUpdate(objKPIView);
      }

 
    }

    return true;

  }

  GetBandColorClass(slaRuleUno: number) {
    
    let targetEnValue = 0;
    //Get Selected Vlaues
    let selectNANR = (this.NANRVal == null || this.NANRVal == undefined) ? '' : this.NANRVal;
    if (selectNANR == '') {

      if (slaRuleUno != 4) {
        let objTargetEnValue = this.kpiRuleForm.get('enteredTargetValue').value;
        //Target Value validation
        if ((this.txtTarget.nativeElement.value == null || this.txtTarget.nativeElement.value.toString() == '' || objTargetEnValue == null || objTargetEnValue == '') && selectNANR == '') {
         // Swal.fire('Error', 'Please Enter the Actual value', 'error')
          //return false;
          targetEnValue = 0;
        }
        //targetEnValue = (objTargetEnValue != '' && objTargetEnValue != null) ? parseInt(objTargetEnValue) : 0;
        targetEnValue = (objTargetEnValue != '' && objTargetEnValue != null) ? parseFloat(objTargetEnValue) : 0;
      }
      else {
        targetEnValue = 0;
      }
      
    

      //0-Target Class Get
      if (slaRuleUno == 3) {
        this.band_calculated = (targetEnValue == 0) ? "green-bar" : "red-bar";
        return true;
      }

      //Pas/Fail Class Get
      if (slaRuleUno == 4) {
        let passfail = (this.kpiRuleForm.get('selectPassFail') != null) ? this.kpiRuleForm.get('selectPassFail').value : '';
        if (passfail == '')
          //Swal.fire('Error', 'Please Select Pass/Fail', 'error')
          this.toaster.show('error', 'Error', 'Please Select Pass/Fail.');
        this.band_calculated = (passfail == 'Fail') ? "red-bar" : "green-bar";
        return true;
      }

      //Other Types Class Get

     // if (targetEnValue > this.actualTargetValue) {
       // Swal.fire('Error', ' Actual Value should <=' + this.actualTargetValue, 'error')
        //return false;
      //}
      this.band_calculated = '';
      let band1Value1 = this.kpiViewBand_data.band1Value1;
      let band2Value1 = this.kpiViewBand_data.band2Value1;
      let band3Value1 = this.kpiViewBand_data.band3Value1;
      let band4Value1 = this.kpiViewBand_data.band4Value1;
      let band5Value1 = this.kpiViewBand_data.band5Value1;
      let band1Condition1 = this.kpiViewBand_data.band1Condition1;
      let band2Condition1 = this.kpiViewBand_data.band2Condition1;
      let classname = this.getBadcolorFinal(slaRuleUno, targetEnValue, band1Value1, band2Value1, band3Value1, band4Value1, band5Value1, band1Condition1, band2Condition1);
      if (classname == '') { this.band_calculated = 'gray-bar'; return false; } else { this.band_calculated = classname; }


      //if (this.band_calculated == 'red-bar') {
      //  this.kpiRuleForm.get('justification').enable();
      //}
      //else {
      //  this.kpiRuleForm.get('justification').reset();
      //  this.kpiRuleForm.get('justification').disable();
      //}
    }
    else {
      this.band_calculated = 'gray-bar';
    }

  }

  getBadcolorFinal(slaRuleUno: any, targetEnValue: any, band1Value1: number, band2Value1: number, band3Value1: number, band4Value1: number, band5Value1: number, band1Condition1: number, band2Condition1: number) {
    
    
    let classname: string = '';
    let targetEnValue_tmp = targetEnValue;
    if ((this.kpiViewBand_data.bandtype == 2)) {

      targetEnValue_tmp = ((targetEnValue / this.actualTargetValue) * 100).toFixed();

    }
    if (slaRuleUno == 2) {
      
      let tr = (this.actualTrend == "1") ? 1 : -1;
      targetEnValue_tmp = (((targetEnValue - this.actualTargetValue) * tr) / this.actualTargetValue) * 100;
      targetEnValue_tmp = (targetEnValue_tmp > 100) ? 100 : targetEnValue_tmp;
    }
    if (slaRuleUno == 11) {
      //if (targetEnValue > band5Value1) {
      //Swal.fire('Error', ' Target Value should <=' + band5Value1, 'error')
      //classname='';
      // }

      if (targetEnValue_tmp <= band1Value1) {
        classname = "red-bar";
      }
      else if ((targetEnValue_tmp >= band1Value1) && (targetEnValue_tmp <= band2Value1)) {

        classname = "red-bar";
      }
      else if ((targetEnValue_tmp >= band2Value1) && (targetEnValue_tmp <= band3Value1)) {

        classname = "orange-bar";
      }
      else if ((targetEnValue_tmp >= band3Value1) && (targetEnValue_tmp <= band4Value1)) {

        classname = "yellow-bar";
      }
      else if ((targetEnValue_tmp >= band4Value1) && (targetEnValue_tmp < band5Value1)) {

        classname = "light-green-bar";
      }
      else if (targetEnValue_tmp >= band5Value1) {

        classname = "green-bar";
      }
    }
    else if (slaRuleUno == 2 || slaRuleUno == 1) {

      
      //if (targetEnValue_tmp <= band1Value1) {
      //  classname = "red-bar";
      //}
      //else if ((targetEnValue_tmp >= band1Value1) && (targetEnValue_tmp <= band2Value1)) {

      //  classname = "green-bar";
      //}
      //else if (targetEnValue_tmp > band2Value1) {

      //  classname = "green-bar";
      //}

      if (
        (targetEnValue_tmp > band1Value1 && band1Condition1 == 1) || //conditon type >
        (targetEnValue_tmp >= band1Value1 && band1Condition1 == 2) || //conditon type >=
        (targetEnValue_tmp == band1Value1 && band1Condition1 == 3) || //conditon type ==
        (targetEnValue_tmp < band1Value1 && band1Condition1 == 4) || //conditon type <
        (targetEnValue_tmp <= band1Value1 && band1Condition1 == 5)  //conditon type <=
      ) {
        classname = "red-bar";
      }
      if (
        (targetEnValue_tmp > band2Value1 && band2Condition1 == 1) || //conditon type >
        (targetEnValue_tmp >= band2Value1 && band2Condition1 == 2) || //conditon type >=
        (targetEnValue_tmp == band2Value1 && band2Condition1 == 3) || //conditon type ==
        (targetEnValue_tmp < band2Value1 && band2Condition1 == 4) || //conditon type <
        (targetEnValue_tmp <= band2Value1 && band2Condition1 == 5)  //conditon type <=
      ) {
        classname = "green-bar";
      }
      //entered value is greater than the target value then passed as green (Well performed) -- when performance is empty
      if (classname == '') {
        if (targetEnValue >= this.actualTargetValue)
          classname = "green-bar";
        else {
        //this.toaster.show('error', 'Error', 'Something went wrong in the KPI Band value configuration.');
        }
      }
    }
    else if (slaRuleUno == 3) {

      
      if (targetEnValue_tmp == 0) {
        classname = "green-bar";
      }
      else {

        classname = "red-bar";
      }

    }

    return classname;
  }

  getWellPerform(slaRuleUno: any, classname:string) {
    let rtnValue: number = 0;
    if (slaRuleUno == 11) {
      if (classname == 'red-bar') {
        rtnValue = (this.kpiViewBand_data.band1wellperform) ? 1 : 0;
      }
      else if (classname == 'orange-bar') {
        rtnValue = (this.kpiViewBand_data.band2wellperform) ? 1 : 0;
      }
      else if (classname == 'yellow-bar') {
        rtnValue = (this.kpiViewBand_data.band3wellperform) ? 1 : 0;
      }
      else if (classname == 'light-green-bar') {
        rtnValue = (this.kpiViewBand_data.band4wellperform) ? 1 : 0;
      }
      else if (classname == 'green-bar') {
        rtnValue = (this.kpiViewBand_data.band5wellperform) ? 1 : 0;
      }
    }
    if (slaRuleUno == 2 || slaRuleUno == 1) {
      if (classname == 'red-bar') {
        rtnValue = (this.kpiViewBand_data.band1wellperform) ? 1 : 0;
      }
      else if (classname == 'green-bar') {
        rtnValue = (this.kpiViewBand_data.band2wellperform) ? 1 : 0;
      }
    }
    if (slaRuleUno == 3) {
      if (classname == 'red-bar') {
        rtnValue =  0;
      }
      else if (classname == 'green-bar') {
        rtnValue = 1;
      }
    }
    return rtnValue;
  }

  CallUpdate(objKPIView: kpiViewWorkFlow) {

    //if (this.uploadedFiles && this.uploadedFiles.length > 0) {

    //  if (this.uploadedFiles.length > 5) {
    //    this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload');
    //    return false;
    //  }

    //  for (var i = 0; i < this.uploadedFiles.length; i++) {
    //    let allowFileSize = false;
    //    let fileSize = this.uploadedFiles[i].size;
    //    allowFileSize = this.userService.checkFileSize(fileSize);
    //    if (!allowFileSize) {
    //      this.toaster.show('error', 'Error', 'Maximum 30 MB File to be upload');
    //      return false;
    //    }
    //  }
    //}

    objKPIView.tenantUno = 1;
    objKPIView.dataOwnerUno = this.kpiCodeDetail.dataOwnerActionByUno.toString();
    objKPIView.level1ApproverUno = this.kpiCodeDetail.level1ApproverUno;
    objKPIView.level2ApproverUno = this.kpiCodeDetail.level2ApproverUno;
    objKPIView.level3ApproverUno = this.kpiCodeDetail.level3ApproverUno;
    objKPIView.kpiYear = this.kpiCodeDetail.kpiYear;
    objKPIView.kpiQuarter = this.kpiCodeDetail.kpiQuarter;
    objKPIView.kpiUno = this.kpiCodeDetail.kpiUno;
    objKPIView.kpiNameEn = this.kpiCodeDetail.kpiNameEn;
    objKPIView.kpiYearName = this.kpiCodeDetail.kpiYearName;
    objKPIView.kpiQuarterName = this.kpiCodeDetail.kpiQuarterName;
    objKPIView.targetValue = (this.kpiCodeDetail.actualValue != null && this.kpiCodeDetail.actualValue != '' && this.kpiCodeDetail.actualValue != undefined) ? parseInt(this.kpiCodeDetail.actualValue) : 0;//this.kpiCodeDetail.targetValue;
    objKPIView.actualTargetValue = this.kpiCodeDetail.actualTargetValue;

    var tval = (this.kpiCodeDetail.actualValue != null && this.kpiCodeDetail.actualValue != '' && this.kpiCodeDetail.actualValue != undefined) ? parseInt(this.kpiCodeDetail.actualValue) : 0;
    
    objKPIView.targetValueText = tval.toString();
    objKPIView.actualValueText = objKPIView.targetEnteredValue.toString();
    //XML Value For KPI Dynamic Transaction
    
    if (this.dynamicRow_data.length > 0 && this.isDynamicEntry == 'true') {
      let strXmlValue = '<roots>';
      for (var i = 0; i < this.dynamicRow_data.length; i++) {

        //let txtvalue: any = document.getElementById('txtValue_' + i) as HTMLInputElement;
        strXmlValue += "<root>";
        strXmlValue += "<KPIDynamicLabel>" + this.dynamicRow_data[i].label + "</KPIDynamicLabel>";
        strXmlValue += "<KPIDynamicValue>" + this.dynamicRow_data[i].value + "</KPIDynamicValue>";
        strXmlValue += "<KPIUno>" + objKPIView.kpiUno + "</KPIUno>";
        strXmlValue += "<Year>" + objKPIView.kpiYear + "</Year>";
        strXmlValue += "<Quarter>" + objKPIView.kpiQuarter + "</Quarter>";
        strXmlValue += "<TenantUno>" + objKPIView.tenantUno + "</TenantUno>";
        strXmlValue += "</root>";
      }
      strXmlValue += '</roots>';
      
      objKPIView.xmlValue = strXmlValue;
    }
    else {
      objKPIView.xmlValue = "";
    }
    
    this.restApi.addKpiViewWorkflow(objKPIView)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
        else {
          this.toaster.show('success', 'KPI Saved Successfully');
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Saved Successfully',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          
          var temp = this;
          //setTimeout(function () {
          //  temp.saveFile();
          //}, 300);
          //this.saveFile();
          this.kpiRuleForm.reset();
          this.kpiCommentForm.reset();
         this.loadKPIViewComments(this.kpiTrnUno, true);
        }


        this.spinner.hide();
        //this.router.navigateByUrl('/kpiinbox');
        this.backtoInbox();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
    return true;
  }
  onchangeNANR(e) {
    
    this.NANRVal = '';
    if (e != null && e) {
      this.NANRVal = 'NA';
      this.kpiRuleForm.get('enteredTargetValue').reset();
      this.kpiRuleForm.get('enteredTargetValue').disable();

      this.kpiRuleForm.get('selectPassFail').reset();
      this.kpiRuleForm.get('selectPassFail').disable();
      this.band_calculated = 'gray-bar';

    }
    else {
      this.NANRVal = '';
      this.kpiRuleForm.get('enteredTargetValue').enable();
      this.kpiRuleForm.get('selectPassFail').enable();
    }
  }

  openSubmitIssueDialog(slaRuleUno: any) {
  
    this.modalRef = this.modalService.show(
      this.IssueDialog,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
    this.onLoadIssues();
  }
  onSubmitIssue() {
    
    if (this.issueComment == null || this.issueComment.trim() == '') {
      //Swal.fire('Error', 'Please Enter Comment', 'error')
      this.toaster.show('error', 'Error', 'Please Enter Comment.');
        return false;
      }
    

    let objKPIView = new kpiViewWorkFlow();
    objKPIView.kpiUno = this.kpiUno;
    objKPIView.kpiTrnUno = this.kpiTrnUno;
    objKPIView.issueUno = 0;
    objKPIView.action = "1";
    objKPIView.comment = this.issueComment;
    objKPIView.userUno = this.login_UserID;
    objKPIView.tenantUno = 1;
    
    this.spinner.show();
    this.restApi.addKpiIssue(objKPIView)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
        else {
          this.toaster.show('success', 'Success', 'KPI Saved Successfully.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Saved Successfully',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.kpiRuleForm.reset();
          this.kpiCommentForm.reset();
           
        }


        this.spinner.hide();
        //this.router.navigateByUrl('/kpiinbox');
        this.backtoInbox();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
    return true;
  }
  onLoadIssues() {
    let objKPIView = new kpiViewWorkFlow();
    objKPIView.kpiUno = this.kpiUno;
    objKPIView.kpiTrnUno = this.kpiTrnUno;    
    objKPIView.userUno = this.login_UserID;
    objKPIView.condition = 1;
    objKPIView.languageUno = 1033;
    objKPIView.tenantUno = 1;
    this.spinner.show();
    this.restApi.loadKpiIssue(objKPIView)
      .subscribe(data => {
        
          this.kpiIssue_data = data;
             
        this.spinner.hide();       
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
    return true;
  }

  

  onApproveRejectSubmit(currentLevel: number,type:string) {

    let objKPIView = new kpiViewWorkFlow();
    if (this.currentLevel == 1) {
      objKPIView.action = 'Level 1 ' + type;
    }
    else if (this.currentLevel == 2) {
      objKPIView.action = 'Level 2 ' + type;
    }
    else if (this.currentLevel == 3) {
      objKPIView.action = 'Level 3 ' + type;
    }

    objKPIView.kpiTrnUno = this.kpiTrnUno;
    objKPIView.userUno = this.login_UserID;
    objKPIView.condition = (type == 'Rejected') ? this.currentLevel + 3 : this.currentLevel;//(this.pageAction == "add") ? 0 : 1;
    objKPIView.actionType = type;
    objKPIView.saveAction = 'submit';
    let comment = this.ApproveOrRejectComments; //this.kpiRuleForm.get('comment').value; 
    objKPIView.comment = comment;

    


    if (type == 'Approved') {
      this.submitApproveReject(objKPIView);
    }
    else {
     

      if (comment == null || comment.trim() == '' ) {
        //Swal.fire('Error', 'Please Enter the Comment', 'error')
        this.toaster.show('error', 'Error', 'Please Enter the Comment.');
        return false;
      }
      else {
        //Swal.fire({
        //  title: 'Reject',
        //  text: 'Please Confirm to Reject the KPI',
        //  type: 'warning',
        //  showCancelButton: true,
        //  confirmButtonText: 'Ok',
        //  cancelButtonText: 'Cancel'
        //}).then((result) => {
        //  if (result.value) {
        //    this.submitApproveReject(objKPIView);
        //    return;
        //  } else if (result.dismiss === Swal.DismissReason.cancel) {

        //    return;
        //  }
        //})

        this.submitApproveReject(objKPIView);
      }

      
    }
    return true;
  }
  submitApproveReject(objKPIView: any) {

    objKPIView.dataOwnerUno = this.kpiCodeDetail.dataOwnerActionByUno.toString();
    objKPIView.level1ApproverUno = this.kpiCodeDetail.level1ApproverUno;
    objKPIView.level2ApproverUno = this.kpiCodeDetail.level2ApproverUno;
    objKPIView.level3ApproverUno = this.kpiCodeDetail.level3ApproverUno;
    objKPIView.kpiYear = this.kpiCodeDetail.kpiYear;
    objKPIView.kpiQuarter = this.kpiCodeDetail.kpiQuarter;
    objKPIView.kpiUno = this.kpiCodeDetail.kpiUno;
    objKPIView.kpiNameEn = this.kpiCodeDetail.kpiNameEn;
    objKPIView.kpiYearName = this.kpiCodeDetail.kpiYearName;
    objKPIView.kpiQuarterName = this.kpiCodeDetail.kpiQuarterName;
    objKPIView.targetValue = this.kpiCodeDetail.targetValue;
    objKPIView.actualTargetValue = this.kpiCodeDetail.actualTargetValue;
    objKPIView.tenantUno = 1;
    objKPIView.userUno = this.login_UserID;


    objKPIView.targetValueText = this.kpiCodeDetail.actualValueText;
    objKPIView.actualValueText = this.kpiCodeDetail.targetValueText;
    objKPIView.passFail = this.kpiCodeDetail.passFail;
    objKPIView.isNANRNT = this.kpiCodeDetail.isNANRNT;

    this.restApi.addKpiViewWorkflow(objKPIView)
      .subscribe(data => {
        
        this.modalRef.hide();
        if (data != null && data != undefined && data != '') {
          //Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
        else {

          this.toaster.show('success', 'Success', 'KPI Saved Successfully.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Saved Successfully',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.kpiRuleForm.reset();
          
          //this.loadKPIViewComments(this.kpiTrnUno, true);
        }
        this.spinner.hide();
       // this.router.navigateByUrl('/kpiinbox');
        this.backtoInbox();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  AddEditKPIViewComment(comment:string,postion:string) {
   

    if (comment == null || comment.trim() == '') {
      this.toaster.show('warning', 'Warning', 'Please enter comment.');
      //Swal.fire('Error', 'Please Enter the Comment', 'error')
      return false;
    }
    
    let action = '';
    //if (this.currentLevel == 0) {
    //  action = 'Data Entry'
    //}
    //else if (this.currentLevel == 1) {
    //  action = 'Level 1'
    //}
    //else if (this.currentLevel == 2) {
    //  action = 'Level 2'
    //}
    //else if (this.currentLevel == 3) {
    //  action = 'Level 3'
    //}
    let objKPIView = new kpiViewComment();


    objKPIView.kpiTrnCommentUno = 0;
    objKPIView.kpiTrnUno = this.kpiTrnUno;
    objKPIView.comment = comment;
    objKPIView.userUno = this.login_UserID;
    objKPIView.action = action;
    objKPIView.condition = 1;//(this.pageAction == "add") ? 0 : 1;
    
    this.restApi.addKpiViewComment(objKPIView)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          this.toaster.show('error', 'Error', 'Something went wrong');
          //Swal.fire('Error', 'Something went wrong', 'error')
        }
        else {

          this.toaster.show('success', 'Success', 'Comment Saved Successfully.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'Comment Saved Successfully',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          if (postion == 'top') {
            this.modalRef.hide();
            this.kpiCommentForm.reset();
          }
          else { this.kpiCommentDownForm.reset();}
          
          this.loadKPIViewKPIWorkflow(this.kpiTrnUno, true);
         // this.loadKPIViewComments(this.kpiTrnUno, true);
        }


        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
    return true;

  }

  //Get the KPI issues and list
  viewKPIIssue(kpiTrnUno: any) {

    this.spinner.show();
    let inpValue = new kpiViewComment();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = 1;
    inpValue.userUno = this.login_UserID;
    this.commentStartIndex = (this.commentStartIndex == undefined || this.commentStartIndex < 1) ? 1 : this.commentStartIndex;
    inpValue.startIndex = this.commentStartIndex;
    inpValue.maxCount = this.commentMaxCount;

    this.restApi.getKpiViewIssue(inpValue)
      .subscribe(data => {

        if (data != null && data != undefined) {
          this.kpiViewIssue_data = data;
          const mockDataset = [];
          for (let i = 0; i < this.kpiViewIssue_data.length; i++) {
            mockDataset[i] = {
              id: i + 1,
              postedBy: this.kpiViewIssue_data[i].postedBy,
              postedDate: this.kpiViewIssue_data[i].postedDate,
              comment: this.kpiViewIssue_data[i].comment,
            };
          }
          this.datasetIssues = mockDataset;
          this.setIssueDefn();
        }
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  exportToExcelIssue() {
    var temp = this;
    setTimeout(function () {
      temp.issueGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }

  exportToExcelCmt() {
    var temp = this;
    setTimeout(function () {
      temp.cmtsGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  cmtsGridReady(angularGrid: AngularGridInstance) {
    this.cmtsGrid = angularGrid;
  }
  issueGridReady(angularGrid: AngularGridInstance) {
    this.issueGrid = angularGrid;
  }
  setCommentDefn() {
    this.columnCommentDefinitions = [
      /*{ id: 'action', name: 'Action', field: 'action', sortable: true },*/
      { id: 'postedBy', name: 'Action By', field: 'postedBy', sortable: true },
      { id: 'postedDate', name: 'Date', field: 'postedDate', sortable: true },
      { id: 'comment', name: 'Comment', field: 'comment', sortable: true }, 

    ];
  }

  setIssueDefn() {
    this.columnIssueDefinitions = [
      { id: 'postedBy', name: 'Action By', field: 'postedBy', sortable: true },
      { id: 'postedDate', name: 'Date', field: 'postedDate', sortable: true },
      { id: 'comment', name: 'Comment', field: 'comment', sortable: true },

    ];
  }

  backtoInbox() {
    var objFilterItem = this.utilityService.InboxFilter_get();
    if (objFilterItem != null && objFilterItem != undefined) {
      if (objFilterItem.filterBy != 0) {
        let filterSla_default = objFilterItem.filterBy;
        if (filterSla_default == 1) { this.router.navigateByUrl('/inbox/dataentry'); }
        if (filterSla_default == 2) { this.router.navigateByUrl('/inbox/approval'); }
        if (filterSla_default == 3) { this.router.navigateByUrl('/inbox/completed'); }

      }
      else {
        this.router.navigateByUrl('/inbox/dataentry');
      }
    }
    else {
      this.router.navigateByUrl('/inbox/dataentry'); 
    }
  }
  showEntryDialog() {
    
    this.dynamicBinding_data = [];
    for (var i = 0; i < this.dynamicLabel_data.length; i++) {
      if (this.dynamicLabel_data[i] != '') {
        let label = this.dynamicLabel_data[i];
        let filterData = this.trnDynamicLabel_data.filter(x => x.kpiDynamicLabel == this.dynamicLabel_data[i]);

        if (filterData != null && filterData.length > 0) {
          let item = { label: this.dynamicLabel_data[i], value: filterData[0].kpiDynamicValue };
          this.dynamicBinding_data.push(item);
        }
        else {
          let item = { label: this.dynamicLabel_data[i], value: '' };
          this.dynamicBinding_data.push(item);
        }
      }
    }
    
    //this.EntryDialog.show();
    this.modalDynamicRef = this.modalService.show(
      this.DynamicLabelDialog,
      Object.assign({}, {
        class: 'gray modal-medium',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }

  onClickOK() {
    
    if (this.dynamicBinding_data.length > 0) {
      this.dynamicRow_data = [];
      for (var i = 0; i < this.dynamicBinding_data.length; i++) {

        let txtvalue: any = document.getElementById('txtValue_' + i) as HTMLInputElement;
        
        let item = { label: this.dynamicBinding_data[i].label, value: txtvalue.value };
        this.dynamicRow_data.push(item);
      }
      
    }
    this.modalDynamicRef.hide();
  }

  

 
  saveFile() {
    
    if (this.uploadedFiles && this.uploadedFiles.length > 0) {
      //if (this.uploadedFiles.length > 5) {
      //  this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload');
      //  return false;
      //}
      let formData = new FormData();
      let isFileReadyForUpload = false;
      for (var i = 0; i < this.uploadedFiles.length; i++) {
        let allowFile = false;
        let fileName = this.uploadedFiles[i].name.toLowerCase();

        let fileSize = this.uploadedFiles[i].size;
        //Check file size
        let allowFileSize = false;
        allowFileSize = this.userService.checkFileSize(fileSize);
        if (!allowFileSize) {
          this.toaster.show('error', 'Error', 'A file size should not above 30MB.');
          return;
        }
        //To check filee size exe  
        allowFile = this.userService.checkFileValuranabity(fileName, fileSize);

        if (allowFile) {
          formData.append("file", this.uploadedFiles[i]);
          isFileReadyForUpload = true;
        }
      }
      if (isFileReadyForUpload) {

        formData.append("kpiUno", this.kpiUno.toString());
        formData.append("kpiTrnUno", this.kpiTrnUno.toString());
        formData.append("userID", this.login_UserID.toString());
        this.restApi.kpiDynamicsAttachmentUpload(formData)
          .subscribe(data => {

            if (data == null && data == undefined && data == '') {
              
            }
            else {
              //  this.toaster.show('success', 'Success', 'File uploaded.');
              //this.RefreshDirectory();
              //this.selectedRecord = new fileManager();
              this.uploadedFiles = [];


            }
            this.getMstKPIDynamicAttachments(this.kpiTrnUno);
            this.spinner.hide();
          },
            (error) => {
              this.spinner.hide();
              this.spinner.hide();
            }
          ).add(() => {
            this.spinner.hide();
          });
      }
    }
    //else {
    //  this.toaster.show('error', 'Error', 'Please select the file');
    //}
  }

  onFileChange(e) {
    
    //if (this.uploadedFiles.length > 5) {
    //  this.toaster.show('error', 'Error', 'You can upload maximum 5 files');
    //  return false;
    //}

    //let allowFileSize = false;
    //let fileSize = this.uploadedFiles[0].size;
    //allowFileSize = this.userService.checkFileSize(fileSize);
    //if (!allowFileSize) {
    //  this.toaster.show('error', 'Error', 'Maximum 30 MB File to be upload');
    //  return false;
    //}
    if (this.uploadedFiles && this.uploadedFiles.length > 0) {
      //Check file count 
      if (this.uploadedFiles.length > 5) {
        this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload.');
        return false;
      }

      for (var i = 0; i < this.uploadedFiles.length; i++) {
        let fileName = this.uploadedFiles[i].name.toLowerCase();
        let fileSize = this.uploadedFiles[i].size;
        //Check file size
        if (!this.userService.checkFileSize(fileSize)) {
          this.toaster.show('error', 'Error', 'A file size should not above 30MB.');
          return false;
        }
        //To check file exe
        if (!this.userService.checkFileValuranabity(fileName, fileSize)) {
          this.toaster.show('error', 'Error', 'Please select the correct format file.');
          return false;
        }
      }
    }

    this.saveFile();
    
  }
  getFileIconClass(fileTitle: string) {

    if (fileTitle == '' || fileTitle == null)
      return "fa fa-file";

    var rtnClass = "fa fa-file";
    var strTitle = (fileTitle.indexOf('.') > 0) ? fileTitle.split('.')[1].toLowerCase() : 'unknown';

    switch (strTitle) {
      case 'txt':
        rtnClass = "fa fa-file-o";
        break;
      case 'doc':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'docx':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'xls':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'xlsx':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'pdf':
        rtnClass = "fa fa-file-pdf-o";
        break;
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'png':
        rtnClass = "fa fa-file-picture-o";
        break;
      case 'mp3':
        rtnClass = "fa fa-file-audio-o";
        break;
      case 'mp4':
      case 'mpeg':
      case 'mpg':
      case 'avi':
        rtnClass = "fa fa-file-video-o";
        break;
      default:
        rtnClass = "fa fa-file";
        break;
    }

    return rtnClass;

  }

  getMstKPIDynamicAttachments(kpiTrnUno: number) {
    this.dynamicAttachments = [];
    this.spinner.show();
    let inpValue = new kpiDynamic();
    inpValue.kpiTrnUno = kpiTrnUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getKpiDynamicsAttachment(inpValue)
      .subscribe(data => {

        // let objData: any = data;
        
        this.dynamicAttachments = data;

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }
  onDeleteAttachment(attachmentUno: number) {

    Swal.fire({
      title: '',
      html: 'Please confirm to delete this attachment' ,
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.value) {

        this.spinner.show();
        let inpValue = new kpiDynamic();
        inpValue.kpiTrnUno = this.kpiTrnUno;
        inpValue.AttachmentUno = attachmentUno;
        inpValue.tenantUno = this.tenantUno;
        inpValue.userUno = this.login_UserID;
        this.restApi.deleteKpiDynamicsAttachment(inpValue)
          .subscribe(data => {

            
            if (data != null && data != undefined && data != '') {
              // Swal.fire('Error', 'Something went wrong!', 'error')
              this.toaster.show('error', 'Error', 'Something went wrong');
            }
            else {
              //Swal.fire({
              //  type: 'success',
              //  title: 'KPI deleted.',
              //  showConfirmButton: false,
              //  timer: 1500
              //})
              this.toaster.show('success', 'Success', 'Attachment deleted successfully.');
              this.getMstKPIDynamicAttachments(this.kpiTrnUno);
            }
            this.spinner.hide();
          },
            (error) => {
              //Called when error
              this.spinner.hide();
            }
          ).add(() => {
            //Called when operation is complete (both success and error)
            this.spinner.hide();
          });
        
        


        return false;
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        
        return;
      }
    })

    
  }
  //kpipertrend = () => {
  //      const data = google.visualization.arrayToDataTable([
  //        ['Year', 'Target', 'Actual' ],
  //    ['2017', 1000, 400],
  //    ['2018', 1170, 460],
  //    ['2019', 660, 1120],
  //    ['2020', 1030, 540],
  //    ['2021', 1030, 0],
  //    ['2022', 1030, 0],
  //    ['2023', 1030, 0]
  //      ]);
  //  const view = new google.visualization.DataView(data);
   

  //  const options = {
  //    title: 'KPI Performance Trend',
  //    subtitle: 'Target, Actual: 2017-2023',
  //    colors: ['#de8060', '#68b097'],
     
  //    legend: { position: 'top', alignment: 'start' },
  //    //chartArea: { left: 50, top: 50, bottom: 50, right: 50, width: "100%", height: "100%" },
     
  //  };

  //  const chart = new google.charts.Bar(document.getElementById('kpipertrend_chart_div_m'));
  //  chart.draw(data, options);
  //}


  kpipertrend = (option_data: any) => {
    

    let tempArray_XAxis = [];
    let tempArray_Target = [];
    let tempArray_Actual = [];

    let sumofActualValue = 0;
    let sumofTargetValue = 0;
    for (var i = 0; i < option_data.length; i++) {
      let kpiYearName = option_data[i].kpiYearName;
      let actualTargetValue = (option_data[i].actualTargetValue != null) ? option_data[i].actualTargetValue : 0; //&& option_data[i].actualTargetValue > 0
      let targetValue = (option_data[i].targetValue != null) ? option_data[i].targetValue : 0; //&& option_data[i].targetValue > 0
      sumofActualValue += parseInt(actualTargetValue);
      sumofTargetValue += parseInt(targetValue);

      tempArray_XAxis.push(kpiYearName);
      tempArray_Actual.push(parseInt(actualTargetValue));
      tempArray_Target.push(parseInt(targetValue));
      
     // tempArray.push([option_data[i].kpiYearName, parseInt(option_data[i].actualTargetValue), parseInt(option_data[i].targetValue)]);
    }

    if (sumofActualValue > 0 && sumofTargetValue > 0 && this.tenantUno == 2 && this.kpiCodeDetail.isYTD==1) {

     tempArray_XAxis.push('YTD');
     tempArray_Actual.push(sumofActualValue);
     tempArray_Target.push(sumofTargetValue);
     
    }

    if (this.tenantUno == 2 && this.kpiCodeDetail.isYTD == 0) {
      //this.chartType_data = [
      //  { value: 'month', text: 'Month' }
      //];
      this.isdisableChartFilter = true;
      this.chartValue = 'month';
    }
    this.chartOption   = {
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['Actual', 'Target'],
        bottom: '0',
        left: 'center',
        //padding: [
        //  20,  // up
        //  0, // right
        //  0,  // down
        //  0, // left
        //],
      },
      color: ['#68b097', '#9e9e9e'],
      toolbox: {
        show: true,
        feature: {
          //dataView: { show: true, readOnly: false },
          //magicType: { show: true, type: ['line', 'bar'] },
          //restore: { show: true },
          //saveAsImage: { show: true }
        }
      },
      calculable: true,
      xAxis: [
        {
          type: 'category',
          data: tempArray_XAxis
        }
      ],
      yAxis: [
        {
          type: 'value'
        }
      ],
      grid: {
        left: '0',
        top: '10%',
        right: '0',
        bottom: '10%',
        containLabel: true
      },
      dataZoom: [
        {
          show: true,
          start: 1,
          end: 100,
          right: '2%',
          left: '5%',
          top: '85%',
          fillerColor: 'rgba(255, 255, 255, 0)',
          borderColor: '#fff',
          //backgroundColor: 'rgba(255, 255, 255, 1)',
          dataBackground: {
            areaStyle: {
              color: 'rgba(255, 255, 255, 1)',
            }
          },
          showDataShadow: false,
          showDetail: false,
          //zoomSelectionColor: '#fff',
          moveHandleSize: 1.
        },


      ],
      series: [
       
        {
          name: 'Actual',
          type: 'bar',
          data: tempArray_Actual,
          barWidth: "10%",

        },
        {
          name: 'Target',
          type: 'bar',
          data: tempArray_Target,
          barWidth: "10%",

        }
      ]
    };

     
  }
  
  toggleMenu() {

  }
  viewKPIChart(kpiUno: any) {
    

    //Get The Chart Value
    
    this.spinner.show();
    let inpValue = new kpiInbox();
    inpValue.kpiUno = kpiUno;
    inpValue.kpiYear = 0;
    inpValue.kpiQuarter = 0;
    inpValue.scheduleText = this.chartValue;
    inpValue.userUno = this.login_UserID;
    this.restApi.getKpiYearWiseChart(inpValue)
      .subscribe(data => {
        this.KPIPerformanceTrend_data = data;
       
          
          setTimeout(() => {

            //google.charts.load('current', { 'packages': ['bar'] });
            //google.charts.setOnLoadCallback(this.kpipertrend(this.KPIPerformanceTrend_data));
            this.kpipertrend(this.KPIPerformanceTrend_data);
          }, 1000);
          this.spinner.hide();
        
      

        // let chartComponent1: any = getInstance('#chart-container', Chart);
        // chartComponent1.refresh();



      },
        (error) => {
          //Called when error
          this.spinner.hide();
          
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        // this.spinner.hide();

      });



  }
  showApporveRejectComment(type: string) {
    
    this.buttonType = type;

    this.modalRef = this.modalService.show(
      this.ApproveRejectDialog,
      Object.assign({}, {
        class: 'gray modal-medium',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }
  onSubmitApproveReject() {
    


    let comment = this.kpiApproveRejectForm.get('comment').value;
    this.ApproveOrRejectComments = (comment != null) ? comment : '';
    if (this.buttonType == 'Approved') {
      
      this.onApproveRejectSubmit(this.currentLevel,'Approved');
    }
    else if (this.buttonType == 'Rejected') {
      this.onApproveRejectSubmit(this.currentLevel, 'Rejected');;
    }


    return false;
  }

  getChartTypeData() {
    if (this.tenantUno == 2) {
      this.chartType_data = [
        { value: 'year', text: 'Year' },
        { value: 'quarter', text: 'Quarter' },
        { value: 'month', text: 'Month' }
      ];
    } else {
      this.chartType_data = [
        { value: 'year', text: 'Year' },
        { value: 'quarter', text: 'Quarter' }

      ];
    }
  }

  onchangeChart(e) {
    

    this.chartValue = (e && e.length > 0) ? e[0].value : 'quarter';
    

    this.viewKPIChart(this.kpiUno);
   
  }

  getPerformanceText(bandColor: string) {
    let rtnText:string=''
    if (bandColor == 'green-bar')
      rtnText = "Well Performing";
    else if (bandColor == 'red-bar')
      rtnText = "Under Performing";
    else if (bandColor == 'gray-bar')
      rtnText = "Pending Result";
    else
      rtnText = '';

    return rtnText;
  }
  getPerformanceApprovalText(bandColor: string) {
    let rtnText: string = ''
    if (bandColor == 'green-bar')
      rtnText = "Well Performing";
    else if (bandColor == 'red-bar')
      rtnText = "Under Performing";
    else if (bandColor == 'gray-bar')
      rtnText = "-";
    else
      rtnText = '-';

    return rtnText;
  }
  getPerformanceBackground(bandColor: string) {
    let rtnText: string = ''
    if (bandColor == 'green-bar')
      rtnText = "bg-light-green";
    else if (bandColor == 'red-bar')
      rtnText = "bg-light-orange";
    else if (bandColor == 'gray-bar')
      rtnText = "bg-light-grey";
    else
      rtnText = '';
    return rtnText;
  }

  getReadMoreUser(user: any, type: any) {
    let rtnUser = user;
    if (user != undefined && user != null && user.length > 0 && user.indexOf(',') > -1) {

      let userArr = user.split(',');
      rtnUser = userArr[0];
      if (type == 'dataowner') { this.isDataReadMore = true; }
      if (type == 'level1') { this.isLevel1ReadMore = true; }
      if (type == 'level2') { this.isLevel2ReadMore = true; }
      if (type == 'level3') { this.isLevel3ReadMore = true; }
    }

    return rtnUser;
  }

  showDataReadMore() {
    this.isShowDataReadMore = !this.isShowDataReadMore;
  }
  showLevel1ReadMore() {
    this.isShowLevel1ReadMore = !this.isShowLevel1ReadMore;
  }
  showLevel2ReadMore() {
    this.isShowLevel2ReadMore = !this.isShowLevel2ReadMore;
  }
  showLevel3ReadMore() {
    this.isShowLevel3ReadMore = !this.isShowLevel3ReadMore;
  }

}
